<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>品牌管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <!--搜索区-->
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="品牌名称">
                        <el-input v-model="searchForm.name" placeholder="品牌中文名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="品牌状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无效" value="0"></el-option>
                            <el-option label="有效" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <!--数据展示区-->
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini"
                          :height="tableConfig.height">
                    <el-table-column label="LOGO" width="130">
                        <template scope="scope">
                            <img width="100%"  :src="'/api'+scope.row.logoUrl">
                        </template>
                    </el-table-column>
                    <el-table-column prop="nameCh" label="中文名称" width="140"/>
                    <el-table-column prop="nameEn" label="英文名称" width="140"/>
                    <el-table-column prop="nameFirstChar" label="首字母" width="80"/>
                    <el-table-column prop="description" label="品牌描述"/>
                    <!-- <el-table-column prop="location" label="品牌显示位置"/>
                    <el-table-column prop="categoryId" label="种类"/> -->
                    <el-table-column prop="status" label="状态" width="80">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status ===  1 ? 'primary' : 'info'" disable-transitions>
                                {{scope.row.status === 1 ? "有效" : "无效" }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="right">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :total="total"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            :current-page="currentPage"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="品牌信息" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <!-- <el-form-item label="品牌所属类型">
                    <el-select v-model="editForm.categoryId" placeholder="请选择品牌所属类型" clearable>
                        <el-option v-for="item in categoryTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="品牌logo" prop="logoUrl">
                    <el-upload
                            class="avatar-uploader"
                            ref="upload"
                            action="/api/admin/upload"
                            name="file"
                            list-type="picture-card"
                            :show-file-list="false"
                            :file-list="fileList"
                            :on-exceed="onExceed"
                            :before-upload="beforeUpload"
                            :on-preview="handlePreview"
                            :on-success="handleSuccess"
                            :on-remove="handleRemove">
                        <img v-if="editForm.logoUrl" width="100%" :src="'/api'+editForm.logoUrl"  class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="中文名称" prop="nameCh">
                    <el-input v-model="editForm.nameCh" placeholder="请输入中文名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="英文名称" prop="nameEn">
                    <el-input v-model="editForm.nameEn" placeholder="请输入英文名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="首字母" prop="nameFirstChar">
                    <el-input v-model="editForm.nameFirstChar" placeholder="请输入首字母" clearable></el-input>
                </el-form-item>
                <el-form-item label="品牌描述">
                    <el-input v-model="editForm.description" placeholder="请输入品牌描述" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editForm.status" placeholder="请选择品牌状态" clearable>
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="品牌显示位置">
                    <el-select v-model="editForm.location" placeholder="请选择品牌显示位置" clearable>
                        <el-option label="上" value="top"></el-option>
                        <el-option label="中" value="middle"></el-option>
                        <el-option label="下" value="down"></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onCancel">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    const HEIGHT_OFFSET = 118;
    export default {
        data() {
            return {
                pageLoading: undefined,
                tableConfig: {
                    height: 0,
                },
                searchForm: {
                    name: "",
                    status: "",
                },
                statusOptions: [
                    {
                        value: "",
                        label: "全部",
                    },
                    {
                        value: "0",
                        label: "无效",
                    },
                    {
                        value: "1",
                        label: "有效",
                    },
                ],
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                editDialogVisible: false,
                editForm: {
                    id: "",
                    logoUrl: "",
                    nameCh: "",
                    nameEn: "",
                    nameFirstChar: "",
                    description: "",
                    // categoryId: "",
                    location: "",
                    status: "1",
                },
                brands: [],
                // categoryTypes: [],
                brand: "",
                bId: "",
                //文件上传的参数
                dialogVisible: false,
                //图片列表（用于在上传组件中回显图片）
                fileList: [{name: '', url: ''}],
                rules: {
                    logoUrl: [
                        { required: true, message: '请选择logo图片', trigger: 'blur' }
                    ],
                    nameCh: [
                        { required: true, message: '请输入中文名称', trigger: 'blur' }
                    ],
                    nameEn: [
                        { required: true, message: '请输入英文名称', trigger: 'blur' }
                    ],
                    nameFirstChar: [
                        { required: true, message: '请输入首字母', trigger: 'blur' }
                    ],
                    status: [
                        { required: true, message: '请选择品牌状态', trigger: 'blur' }
                    ],
                },
            }
        },
        methods: {
            onSearch() {
                let brand = {};
                if (this.searchForm.name != "") {
                    brand["nameCh"] = this.searchForm.name;
                }
                if (this.searchForm.status != "") {
                    brand["status"] = this.searchForm.status;
                }

                this.loading = true;

                let _this = this
                this.$axios.post("/admin/product/brand/search", {
                    cond: brand,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function (error) {
                });
            },
            handleCreate() {
                this.editForm.id = "";
                this.editForm.logoUrl = "";
                this.editForm.nameCh = "";
                this.editForm.nameEn = "";
                this.editForm.nameFirstChar = "";
                this.editForm.description = "";
                this.editForm.status = "1";
                // this.editForm.categoryId = "";
                this.editForm.location = "";
                this.editDialogVisible = true;
            },
            // initCategoryTypes() {
            //     let _this = this;
            //     this.$axios.get("/admin/product/category/all")
            //         .then(function(response) {
            //             let resp = response.data;
            //             if(resp.header.status == 0) {
            //                 _this.categoryTypes.length = 0;
            //                 for(let i=0; i<resp.data.length; i++) {
            //                     let data = resp.data[i];
            //                     _this.categoryTypes.push({
            //                         label: data.name,
            //                         value: data.id,
            //                     })
            //                 }
            //             }
            //         })
            // },
            onSubmit() {
                let that = this;
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/product/brand/save", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                that.editDialogVisible = false;
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                    }
                })

            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleEdit(index, row) {
                this.editForm.id = row.id;
                this.editForm.logoUrl = row.logoUrl;
                this.editForm.nameCh = row.nameCh;
                this.editForm.nameEn = row.nameEn;
                this.editForm.nameFirstChar = row.nameFirstChar;
                this.editForm.description = row.description;
                this.editForm.status = row.status + "";
                this.editForm.location = row.location + "";
                // this.editForm.categoryId = row.categoryId + "";
                this.editDialogVisible = true;
            },
            handleDelete(index, row) {
                let _this = this;
                this.$confirm('是否删除该品牌信息【' + row.nameCh + '】？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.get("/admin/product/brand/delete/" + row.id)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据删除成功',
                                    type: 'success'
                                });
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },
            //文件上传成功的钩子函数
            handleSuccess(res, file) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                if (file.response.data.success) {
                    this.editForm.logoUrl = file.response.data.message; //将返回的文件储存路径赋值picture字段
                }
            },
            //删除文件之前的钩子函数
            handleRemove(file, fileList) {
                this.$message({
                    type: 'info',
                    message: '已删除原有图片',
                    duration: 6000
                });
            },
            //点击列表中已上传的文件事的钩子函数
            handlePreview(file) {
            },
            //上传的文件个数超出设定时触发的函数
            onExceed(files, fileList) {
                this.$message({
                    type: 'info',
                    message: '最多只能上传一个图片',
                    duration: 6000
                });
            },
            //文件上传前的前的钩子函数
            //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isGIF = file.type === 'image/gif';
                const isPNG = file.type === 'image/png';
                const isBMP = file.type === 'image/bmp';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG && !isGIF && !isPNG && !isBMP) {
                    this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
            },
            onCancel() {
                this.$refs.editForm.clearValidate();
                this.editDialogVisible = false;
            },
            setTableHeight() {
                const tablePosition = this.$refs['tablePosition'];
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        created() {
            this.onSearch();
            // this.initCategoryTypes();
            window.addEventListener("resize", this.setTableHeight);
        },
        mounted() {
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                this.setTableHeight();
                this.pageLoading.close();
                this.pageLoading = undefined;
            }, 500);
        },
        beforeDestroy() {
            if(this.pageLoading){
                this.pageLoading.close();
                this.pageLoading = undefined;
            }
        },
        destroyed () {
            window.removeEventListener("resize", this.setTableHeight);
        }
    }
</script>
<style>
</style>
